import * as React from 'react';
import { ComponentProps, ButtonInline } from 'ui/common';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { PreviousValuesItem } from './previous-values-item';
import styles from './previous-values-item.scss';

interface PreviousValuesButtonProps {  
  textDone: string;
  textMoreDetails: string;
  textDetailsHeaderTitle: string;
  textDetailsAmount: string;
  textDetailsPeriodStart: string;
  textDetailsPeriodEnd: string;
  /** 
   * @internal 
   */
  previousEnvironmentalValues: any;
}

export type PreviousValuesButtonComponentProps = ComponentProps & OpenStateInjectedProps & PreviousValuesButtonProps;

export class PreviousValuesButtonComponent extends React.Component<PreviousValuesButtonComponentProps> {

  private closeModal = () => {
    const {isOpen, close} = this.props;

    isOpen && close();
  };

  public render() {
    const {
      previousEnvironmentalValues,
      textMoreDetails,
      textDone,
      textDetailsHeaderTitle
    } = this.props;
    const {isOpen, open} = this.props;    
    const hasChildren = !!previousEnvironmentalValues.length;
    const greenNo = hasChildren && previousEnvironmentalValues[0].greenNo;
    const substance = hasChildren && previousEnvironmentalValues[0].substance;

    const detailsButton = hasChildren ? (
      <ButtonInline onClick={open} className= {styles.linkButton}>
        {textMoreDetails}
      </ButtonInline>
    ) : null;

    const childItems = 
      <div>
        { previousEnvironmentalValues.map(row => 
          <PreviousValuesItem 
            key={`${row.primaryKey.value}`} 
            {...row}            
            {...this.props}
          />) 
        }
      </div>;

    const modal =
            <ModalWrapper
              headerTitle={`${textDetailsHeaderTitle} ${substance} #${greenNo}`}
              onClose={this.closeModal}
              onDone={this.closeModal}
              btnTitle={textDone}
              largeSize={false}>
                {childItems}
            </ModalWrapper>;

    return (
       <>
        {detailsButton}
        {isOpen && modal}
       </>
    );
  }
}

const c = withOpenState()(PreviousValuesButtonComponent);

export {c as PreviousValuesButton};
